module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10263.fa9f0f0c.jpg";